/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import {
  defaultFont,
  primaryColor,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  grayColor,
  // Biv colors
  //-------------
  violetBiv,
  darkVioletBiv,
  greenBiv,
  lightBlueBiv,
  redBiv,
  yellowBiv,
  orangeBiv,
  lightBlueKW,
  //-------------
} from "assets/jss/material-dashboard-pro-react.jsx";

const typographyStyle = {
  defaultFontStyle: {
    ...defaultFont,
    fontSize: "14px"
  },
  defaultHeaderMargins: {
    marginTop: "20px",
    marginBottom: "10px"
  },
  quote: {
    padding: "10px 20px",
    margin: "0 0 20px",
    fontSize: "17.5px",
    borderLeft: "5px solid" + grayColor[8]
  },
  quoteText: {
    margin: "0 0 10px",
    fontStyle: "italic"
  },
  quoteAuthor: {
    display: "block",
    fontSize: "80%",
    lineHeight: "1.42857143",
    color: grayColor[1]
  },
  mutedText: {
    color: grayColor[1]
  },
  primaryText: {
    color: primaryColor[0]
  },
  infoText: {
    color: infoColor[0]
  },
  successText: {
    color: successColor[0]
  },
  warningText: {
    color: warningColor[0]
  },
  dangerText: {
    color: dangerColor[0]
  },
  // Biv colors
  //----------------------------------
  violetBivText: {
    color: violetBiv[0]
  },
  darkVioletBivText: {
    color: darkVioletBiv[0]
  },
  greenBivText: {
    color: greenBiv[0]
  },
  lightBlueBivText: {
    color: lightBlueBiv[0]
  },
  redBivText: {
    color: redBiv[0]
  },
  yellowBivText: {
    color: yellowBiv[0]
  },
  orangeBivText: {
    color: orangeBiv[0]
  },
  lightBlueKWText: {
    color: lightBlueKW[0]
  },
  //----------------------------------
};

export default typographyStyle;
